export function getParam(name) {
  const results = new RegExp('[?&]' + name + '=([^&#]*)').exec(window.location.href)
  if (results == null) {
    return null
  } else {
    return results[1] || 0
  }
}
